import {initSlickSlider} from './common';
export default {
    init() {
        initSlickSlider($('.news_slider_text'), {
            asNavFor: '.news_slider_image',
        });

        initSlickSlider($('.news_slider_image'), {
            asNavFor: '.news_slider_text',
            arrows: false,
        });
        initSlickSlider($('.home-page-slider'), {
            arrows:true,
            dots:false,
            infinite: true,
            autoplay:true,
            pauseOnHover:false,
            speed: 500,
            fade: true,
            cssEase: 'linear',
        });
        if($('.template-home').length > 0){
           /* tslint:disable */ 
           window.dataLayer.push({

            'brand': 'peugeot',
            'virtualPageURL': '/home',
            'language': 'en',
            'country': 'pk',
            'siteTypeLevel1': 'www.peugeot-luckymotorcorp.com',
            'siteTypeLevel2': 'index',
            'siteOwner': 'local',
            'siteTarget': 'B2C',
            'siteFamily': 'new cars',
            'pageCategory': 'home page',
            
            });
            /* tslint:enable */
        }

            

    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js